export type ReceiptReference = { id: string; receiptNumber: string };
export type FulfillmentStatus = "waiting" | "partially_received" | "received";

// Reuse the desktop receipt sheet; focus/receiptId remain detail-only parameters.
export function purchaseOrderReceiptHref(poId: string, branchId: string, supplierId: string) {
  return `/supplier-receipts?${new URLSearchParams({ create: "1", poId, branchId, supplierId })}`;
}

export function receiptPrefill(search: string) {
  const params = new URLSearchParams(search);
  const poId = params.get("poId");
  const branchId = params.get("branchId");
  const supplierId = params.get("supplierId");
  return params.get("create") === "1" && poId && branchId && supplierId
    ? { poId, branchId, supplierId } : null;
}

// Receipt evidence is not a workflow status and must not close/approve a request.
export function receivingLabel(received: boolean | undefined, receipts: ReceiptReference[], text: (en: string, ar: string) => string) {
  return received === true ? text("Received", "تم الاستلام")
    : receipts.length ? text("Partly received", "تم الاستلام جزئياً") : null;
}
